import * as React from "react";

import DetailsTitle from '../../CustomeComponents/DetailsTitle';
import Section from "../Section";
import TableTabaList from "./TableTabaList";

const TikimTaba = (props) => {

  return (
    <div className="container my-3 my-lg-5">
      <DetailsTitle />

      <Section icon={'folder-small'} title={'תיקים'} className="mt-3">
        <TableTabaList tabaData={props.tabaData}/>
      </Section>
    </div>
  );
}

export default TikimTaba;